import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Row,
    RightComponents,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
} from '../../components/Form';
import {
    TableData,
    TableHeader,
    TableBody,
    TableRow,
    TableColumn,
    EditableSlideToggle,
} from '../../components/Table';
import {
    MobileInfoBox,
    Title,
    TextView,
    PanelBox,
    Modal,
} from '../../components/Display';
import TaroffPeiksEdit from '../peik/TaroffPeiksEdit';
import TaroffPeiksNew from '../peik/TaroffPeiksNew';
import { postData } from '../../Api';

export default function TaroffPeiks(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const handlecomp1 = () => {
        setModal(
            Modal({
                children: <TaroffPeiksNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp2 = () => {
        setModal(
            Modal({
                children: <TaroffPeiksNew onDismiss={() => setModal(null)} />,
                onDismiss: () => setModal(null),
            })
        );
    };
    const [tableData, setTableData] = useState({});
    const [tableSize, setTableSize] = useState(parseInt(allProps['size']) || 20);
    const [tablePage, setTablePage] = useState(parseInt(allProps['page']) || 1);
    const gotoPage = (page, size = undefined) => {
        setTableData({});
        setTablePage(page);
        size && setTableSize(size);
        setSearchParams({ ...searchParams, page: page, size: size || tableSize });
    };
    const clearFilters = () => {
        setSearchParams({});
    };
    const applyFilters = () => {
        const newSearchParams = {};
        navigate({ search: '?' + new URLSearchParams(newSearchParams).toString() });
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-peiks/table-data', {
            size: tableSize,
            page: tablePage,
        }).then((response) => {
            setTableData(response.data);
        });
    }, [searchParams, modal, props]);
    const handlecomp3 = (row) => {
        alert('error in editting slide-toggle value')
    };
    const handlecomp4 = (row) => {
        setModal(
            Modal({
                children: (
                    <TaroffPeiksEdit
                        taroff-peiks-id={row.param_id}
                        onDismiss={() => setModal(null)}
                    />
                ),
                onDismiss: () => setModal(null),
            })
        );
    };
    const handlecomp5 = (row) => {};
    return (
        <PanelBox>
            <Row>
                <RightComponents>
                    <Title>مدیریت پیک ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp1} color={'secondary'}>
                        ایجاد پیک
                    </Button>
                </LeftComponents>
            </Row>
            <Row>
                <RightComponents>
                    <Title>مدیریت پیک ها</Title>
                </RightComponents>
                <LeftComponents>
                    <Button onClick={handlecomp2} color={'secondary'}>
                        ایجاد پیک
                    </Button>
                </LeftComponents>
            </Row>
            <TableData total={tableData.total} size={tableSize} page={tablePage} setPage={gotoPage}>
                <TableHeader>
                    <TableRow>
                        <TableColumn mobile={true}>mobile</TableColumn>
                        <TableColumn mobile={false}>ردیف</TableColumn>
                        <TableColumn mobile={false}>فعال</TableColumn>
                        <TableColumn mobile={false}>عنوان</TableColumn>
                        <TableColumn mobile={false}>نوع وسیله پیک</TableColumn>
                        <TableColumn mobile={false}>شماره همراه یک پیک</TableColumn>
                        <TableColumn mobile={false}>شماره همراه دو پیک</TableColumn>
                        <TableColumn mobile={false}>زمان درج پیک</TableColumn>
                        <TableColumn mobile={false}>نام کاربری</TableColumn>
                        <TableColumn mobile={false}>حذف</TableColumn>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {tableData.rows?.map((row, index) => (
                        <TableRow key={index}>
                            <TableColumn mobile={true}>
                                <MobileInfoBox />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_id}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <EditableSlideToggle onChange={() => handlecomp3(row)} />
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView bold={true}>{row.text_title}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_vehicle}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_phone_one}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_phone_two}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView format={'persian-date-normal'}>
                                    {row.text_insert_time}
                                </TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <TextView>{row.text_user_id_username}</TextView>
                            </TableColumn>
                            <TableColumn mobile={false}>
                                <LeftComponents>
                                    <Button
                                        onClick={() => handlecomp4(row)}
                                        rightIcon={'far fa-edit'}
                                        tooltip={'ویرایش'}
                                    ></Button>
                                    <Button
                                        onClick={() => handlecomp5(row)}
                                        color={'warn'}
                                        rightIcon={'far fa-trash'}
                                        tooltip={'حذف'}
                                    ></Button>
                                </LeftComponents>
                            </TableColumn>
                        </TableRow>
                    ))}
                </TableBody>
            </TableData>
            {modal && modal}
        </PanelBox>
    );
}
